"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var curation_store_1 = require("../stores/curation_store");
var curated_set_toggle_1 = require("./curated_set_toggle");
var CurationAdmin = /** @class */ (function (_super) {
    tslib_1.__extends(CurationAdmin, _super);
    function CurationAdmin(props) {
        var _this = _super.call(this, props) || this;
        _this.state = curation_store_1.default.getState();
        _this.onCurationStoreUpdated = _this.onCurationStoreUpdated.bind(_this);
        return _this;
    }
    CurationAdmin.prototype.componentDidMount = function () {
        curation_store_1.default.listen(this.onCurationStoreUpdated);
    };
    CurationAdmin.prototype.componentWillUnmount = function () {
        curation_store_1.default.unlisten(this.onCurationStoreUpdated);
    };
    CurationAdmin.prototype.onCurationStoreUpdated = function () {
        this.setState(curation_store_1.default.getState());
    };
    Object.defineProperty(CurationAdmin.prototype, "listingSets", {
        get: function () {
            return this.state.listing_curated_sets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurationAdmin.prototype, "hasListingSets", {
        get: function () {
            return this.listingSets.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    CurationAdmin.prototype.renderSets = function () {
        return this.listingSets.map(function (set) { return React.createElement(curated_set_toggle_1.default, { key: set.curated_set_id, set: set }); });
    };
    CurationAdmin.prototype.render = function () {
        return (React.createElement("div", null,
            this.state.error,
            this.renderSets()));
    };
    return CurationAdmin;
}(React.Component));
exports.default = CurationAdmin;
//# sourceMappingURL=admin.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/curation/admin.js
// module id = 7qGD
// module chunks = 20 21